/**
 * Мок аккаунтов: команда Skrezo, владельцы и врачи клиник, один
 * исключённый и один заблокированный. Мутации меняют записи на месте —
 * после инвалидации список приходит обновлённым, как с живого бэка.
 */

import type {Account} from './types';

const member = (clinicId: string, clinicName: string, roleName: string, isOwner = false) => ({
  membershipId: `${clinicId}-${roleName}-${isOwner ? 'o' : 'm'}`,
  clinicId,
  clinicName,
  roleName,
  isOwner,
  active: true,
});

const acc = (
  id: string,
  fullName: string,
  phone: string,
  extra: Partial<Account> = {},
): Account => ({
  id,
  fullName,
  phone,
  isPlatformAdmin: false,
  blocked: false,
  blockedAt: null,
  blockedReason: null,
  hasActiveMembership: true,
  memberships: [],
  createdAt: '2026-08-12T09:30:00Z',
  ...extra,
});

export const MOCK_ACCOUNTS: Account[] = [
  acc('a-1', 'Команда Skrezo', '+996700000001', {
    isPlatformAdmin: true,
    hasActiveMembership: false,
    createdAt: '2026-07-01T08:00:00Z',
  }),
  acc('a-2', 'Токтогулова Айзада', '+996700111222', {
    memberships: [member('c-1', 'Дента Плюс', 'Владелец', true)],
  }),
  acc('a-3', 'Асанов Руслан', '+996555100200', {
    memberships: [member('c-1', 'Дента Плюс', 'Работник'), member('c-2', 'Смайл Ош', 'Работник')],
  }),
  acc('a-4', 'Кыдырова Нургуль', '+996555110210', {
    hasActiveMembership: false,
    memberships: [{...member('c-1', 'Дента Плюс', 'Работник'), active: false}],
  }),
  acc('a-5', 'Исаков Тилек', '+996555120220', {
    blocked: true,
    blockedAt: '2026-09-20T12:10:00Z',
    blockedReason: 'Уволен, уносил базу пациентов',
    memberships: [member('c-2', 'Смайл Ош', 'Менеджер')],
  }),
];
